import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LogIn from './Pages/LoginPage';
import AppStateContextProvider from './Context/contextState';
import ProjectsPage from './Pages/ProjectsPage';
import 'bootstrap/dist/css/bootstrap.css'
import './GelobalComponents/font.css'
import ProjectFiles from './Pages/ProjectFiles';
import FilePage from './Pages/FilePage';
import ProjectPagePubish from './Pages/PublishFie';
import { useEffect } from 'react';

function App() {

  useEffect(() => {
    document.title = "3DPanel";
  }, [])
  return (
    <>

      <div className='body' dir="rtl">
        <AppStateContextProvider>
          <Router>
            <Routes>
              <Route path='/' element={<LogIn />} />
              <Route path='/projects' element={<ProjectsPage />} />
              <Route path='/projects/:projectId1' element={<ProjectFiles />} />
              <Route path='/projects/:projectId1/:fileId' element={<FilePage />} />
              <Route path='/:publishId' element={<ProjectPagePubish />} />
            </Routes>
          </Router>
        </AppStateContextProvider>
      </div>

    </>
  );
}

export default App;
